/**
 * One-time information about the storage the game uses (no consent banner: only strictly necessary storage and the
 * player's own settings, no analytics/ads). Not blocking, not a wall: an in-flow strip that is remembered once dismissed.
 * The memory itself is a localStorage key (listed in /legal/cookies); if storage is unavailable the strip just goes away
 * for this page view.
 */
import { useState } from 'react';
import { LEGAL_PATHS, LEGAL_VERSIONS } from '@galaxis/shared';

export const NOTICE_KEY = 'galaxis.notice.v1';

function read(): string | null {
  try { return typeof localStorage === 'undefined' ? null : localStorage.getItem(NOTICE_KEY); } catch { return null; }
}
function write(v: string): void {
  try { localStorage.setItem(NOTICE_KEY, v); } catch { /* storage unavailable: the notice is gone for this page view only */ }
}

export function CookieNotice() {
  const [seen, setSeen] = useState(() => read() === LEGAL_VERSIONS.cookies);
  if (seen) return null;
  return (
    <div role="region" aria-label="Tájékoztatás a sütikről és a helyi tárolóról" data-testid="cookie-notice"
      className="relative z-20 flex flex-wrap items-center gap-x-3 gap-y-2 px-4 py-2 text-xs text-slate-300"
      style={{ background: 'rgba(15,23,42,0.95)', borderBottom: '1px solid rgba(74,158,255,0.3)' }}>
      <p className="flex-1 min-w-[16rem]">
        Csak a működéshez szükséges sütiket és a beállításaidat megjegyző helyi tárolót használjuk; nincs analitika, hirdetés vagy követés.{' '}
        <a href={LEGAL_PATHS.cookies} className="text-accent underline underline-offset-2" data-testid="cookie-notice-link">Részletek</a>
      </p>
      <button type="button" className="btn-secondary" style={{ minHeight: 44 }} data-testid="cookie-notice-ok"
        onClick={() => { write(LEGAL_VERSIONS.cookies); setSeen(true); }}>Értem</button>
    </div>
  );
}
